<template>
  <sub-menu :links="links" :active="active"></sub-menu>
</template>

<script>
import Meta from '@/mixins/Meta'
import Permissions from '@/mixins/Permissions'
import SubMenu from '@/components/Layout/SubMenu'

export default {
  components: {SubMenu},

  mixins: [Meta, Permissions],

  props: ['publication'],

  computed: {
    links() {
      return [
        {
          id: 'dashboard',
          url: '/publications/' + this.publication.id,
          text: 'Dashboard'
        },
        {
          id: 'edit',
          url: '/publications/' + this.publication.id + '/edit',
          text: 'Edit',
          display: this.hasPermission('admin')
        }
      ]
    },

    active() {
      return this.getMeta('subsection')
    }
  }
}
</script>
